/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/Supplier",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async getAllSupplier() {
    const requestScreenData = {
      url: "api/SupplierList",
      select: ["Code", "Name", "CurrencyCode"],
      orderby: "Name asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async saveSupplier(mode, payload) {
    var url = "api/Save_Supplier";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.put(url, payload.Code, payload, "String");
    }
  },
};

export { SupplierService };
